import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/auth';

@Component({
  selector: 'app-cups-dialog',
  templateUrl: './cups-dialog.component.html',
  styleUrls: ['./cups-dialog.component.scss']
})
export class CupsDialogComponent implements OnInit {

  public country: string;

  constructor(
    public dialogRef: MatDialogRef<CupsDialogComponent>,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.country = this.authService.getUserData().country;
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }
}
